import { useCallback, useContext, useEffect, useState } from 'react';
import Header from '../components/Header';
import Form from 'react-bootstrap/Form';
import Sidebar from '../components/Sidebar'
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useForm } from 'react-hook-form';
import { IMAGE_URL } from '../API';
import { toast } from "react-toastify";
import { BiEditAlt } from "react-icons/bi";
import { ProfileContext } from '../context/ProfileContext';
import Avtar from '../Assets/Images/Avatar.svg'

function EditProfile() {
  const { personalInfo, editProfile, viewProfile } = useContext(ProfileContext)
  const { register, handleSubmit, setValue, clearErrors, formState: { errors }, reset } = useForm();
  const [preview, setPreview] = useState(null);
  const [signaturePreview, setSignaturePreview] = useState(null);
  const [verificationPreview, setVerificationPreview] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);

  const loadFile = useCallback((event) => {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    const file = event.target.files?.[0];

    if (!file) {
      toast.error("Please select a file.");
      return;
    }

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG, PNG, GIF and WebP files are allowed.");
      return;
    }

    if (file.size > 20 * 1024 * 1024) {
      toast.error('File size should not exceed 20MB.');
      return;
    }

    setCurrentImage(file);
    clearErrors('file');

    const imgUrl = URL.createObjectURL(file);
    setPreview(imgUrl);
    setValue('image', file);
  }, [clearErrors, setValue]);

  const handleSignatureUpload = (event) => { setSignaturePreview(URL.createObjectURL(event.target.files?.[0])) }
  const handleVerificationUpload = (event) => { setVerificationPreview(URL.createObjectURL(event.target.files?.[0])) }

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append('name', data.name);
      if (currentImage) { formData.append('image', currentImage) }
      if (data.signature && data.signature[0]) { formData.append('signature', data.signature[0]) }
      if (data.verification_document && data.verification_document[0]) { formData.append('verification_document', data.verification_document[0]) }

      await editProfile(formData);
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!");
    }
  };

  useEffect(() => { viewProfile(); }, []);
  useEffect(() => {
    if (personalInfo) {
      reset(personalInfo);
      if (personalInfo.signature) { setSignaturePreview(`${IMAGE_URL}${personalInfo.signature}`) }
      if (personalInfo.verification_document) { setVerificationPreview(`${IMAGE_URL}${personalInfo.verification_document}`) }
    }
  }, [personalInfo, reset]);

  return (
    <>
      <Header />
      <section className='back-comn-img'>
        <div className="custm-container">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="comn-dashboard-page">
              <div className="comn-back-white">
                <h4 className='dash_page_heading'>Edit Profile</h4>
                <div className="edit-profile-amin">
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className="my-profile-left d-flex employer_logo_edit">
                      <div className="profile-pic">
                        <label className="label" htmlFor="file">
                          <span className="glyphicon glyphicon-camera">
                            <BiEditAlt />
                          </span>
                        </label>
                        <Form.Control id="file" type="file" name="profile_picture"
                          {...register("image")}
                          onChange={(e) => {
                            loadFile(e); setValue('image', e.target.files[0]);
                          }}
                        />
                        <figure className="profile-img-edit">
                          <img
                            src={preview || (personalInfo?.image ? IMAGE_URL + personalInfo?.image : Avtar)}
                            alt="Profile Preview"
                          />
                        </figure>
                      </div>
                    </div>
                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="formGridFullName" className="comn-class-inputs">
                          <Form.Label>Full Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Full Name"
                            autoFocus
                            {...register("name", {
                              required: 'Please enter your full name.',
                              validate: {
                                notOnlySpaces: value => value.trim() !== '' || 'Name cannot be empty or just spaces.'
                              }
                            })}
                          />
                          {errors.name && <span className="error">{errors.name.message}</span>}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="formGridEmail" className='comn-class-inputs'>
                          <Form.Label>Email Address</Form.Label>
                          <Form.Control type="email" placeholder="Enter Email Address" disabled
                            {...register("email", {
                              required: 'Please enter email address.',
                              pattern: {
                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                message: "Please enter valid email address."
                              },

                            })}
                          />
                          {errors.email && <span className='error'>{errors.email.message}</span>}
                        </Form.Group>
                      </Col>

                      {personalInfo?.role === "SUB-ADMIN" && (
                        <Col md={6}>
                          <Form.Group controlId="verificationDocument" className="comn-class-inputs mt-3">
                            <Form.Label>Verification Document (PDF)</Form.Label>

                            <Form.Control
                              type="file"
                              accept="application/pdf"
                              {...register("verification_document")}
                              onChange={handleVerificationUpload}
                            />

                            {errors.verification_document && (<span className="error">{errors.verification_document.message}</span>)}
                          </Form.Group>
                          {verificationPreview && (
                            <div className="mt-2">
                              <iframe
                                src={verificationPreview}
                                title="Verification Document"
                                width="100%"
                                height="300px"
                                style={{ border: "1px solid #ddd" }}
                              />
                            </div>
                          )}
                        </Col>
                      )}
                      {personalInfo?.role === "SUB-ADMIN" && (
                        <Col md={6}>
                          <Form.Group controlId="signature" className="comn-class-inputs mt-3">
                            <Form.Label>Signature</Form.Label>
                            <Form.Control type="file" placeholder="Select image" accept="image/png, image/jpeg, image/jpg, image/webp"
                              {...register("signature")}
                              onChange={handleSignatureUpload}
                            />

                            {errors.signature && (<span className="error">{errors.signature.message}</span>)}
                          </Form.Group>
                          {signaturePreview && (
                            <div className="mt-2">
                              <img
                                src={signaturePreview}
                                alt="Signature Preview"
                                style={{
                                  width: "200px",
                                  height: "100px",
                                  objectFit: "contain",
                                  border: "1px solid #ddd",
                                }}
                              />
                            </div>
                          )}
                        </Col>
                      )}
                    </Row>
                    <button className='main-btn' type="submit">Update Profile</button>
                  </Form>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </>
  );
}

export default EditProfile